import { Button } from "@sellar-io/components";
import { useId, useState } from "react";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../components/modal/Dialog";
import { useFulfillmentTypeCreate } from "../../../hooks/api/v2/fulfillmentType/useFulfillmentTypeCreate";
import { useNavigate } from "react-router";
import * as ROUTES from "../../../constants/routes";
import { apiV2AssertError } from "../../../hooks/api/v2/apiV2Request";
import { useDeliveryMethodContainerRulesContainerTypes } from "../../../hooks/api/v2/deliveryMethodContainerRules/useDeliveryMethodContainerRulesContainerTypes";
import { DeliveryMethodCreateForm } from "./DeliveryMethodCreateForm";

export const DeliveryMethodCreateDialog = ({
  active,
  setActive,
}: {
  active: boolean;
  setActive: (active: boolean) => void;
}) => {
  const navigate = useNavigate();
  const formId = useId();
  const [error, setError] = useState("");
  const { data: availableContainers, isLoading } =
    useDeliveryMethodContainerRulesContainerTypes();
  const fulfillmentTypeCreateMutation = useFulfillmentTypeCreate();

  return (
    <Dialog
      active={active}
      onDismiss={() => setActive(false)}
      fullHeight={true}
    >
      <DialogNavigation
        leftIcon="CHEVRON_DOWN"
        onClickLeftIcon={() => setActive(false)}
        title="New delivery method"
      />
      <DialogContent className="flex flex-col gap-4">
        <DeliveryMethodCreateForm
          formId={formId}
          availableContainers={availableContainers ?? []}
          isLoading={isLoading}
          error={error}
          onSubmit={(request) => {
            setError("");

            fulfillmentTypeCreateMutation.mutate(request, {
              onSuccess: (res) => {
                setActive(false);
                navigate(
                  ROUTES.DELIVERY_METHOD.href({ deliveryMethodId: res.id }),
                );
              },
              onError: (error) => {
                const message =
                  apiV2AssertError(error)?.response?.data.message ??
                  "Failed to create new delivery method";
                setError(message);
              },
            });
          }}
        />
      </DialogContent>
      <DialogCTA>
        <Button
          type="submit"
          form={formId}
          disabled={isLoading}
          loading={fulfillmentTypeCreateMutation.isPending}
        >
          Create
        </Button>
      </DialogCTA>
    </Dialog>
  );
};
